
import { Vue, Component, Emit, Prop, Ref } from "vue-property-decorator";
import MapApp from "@/plugin/gis-viewer/MapAppArcgis2D";
import { IMapContainer, IOverlayParameter, IHeatParameter, IOverlayClusterParameter, IOverlayDelete, ILayerConfig, IPointGeometry, ICenterLevel, IFindParameter, IResult, IDistrictParameter, IStreetParameter, IRouteParameter, IHeatImageParameter, IGeometrySearchParameter, ICustomTip, ISelectRouteParam, ISelectRouteResult, IDrawOverlays, ISelectRouteHitTest, IDefinitionParameter, ITrackParameter, ISignalPhaseInfo, IPopUpTemplate, IQueryParameter, ISumoConnectInfo, ILaneSignalPhaseInfo, ITrackLineParameter, IMapLevel, IRouteHitTestParam, IRouteHitTestResultParam, ITrackCross, ICrossInView, IWidget, IMultiStartRoute, IDynamicLayerDataParams, IComponentOverlayParam, IMapControlParam, IHeatMapParams, IAnimateLineAddParams, IAnimateLineDelParams } from "@/types/map";

@Component({
    name: "MapContainerArcgisTwoD",
})
export default class MapContainerArcgis extends Vue implements IMapContainer {
    private mapApp!: MapApp;

    mapId: string = "divArcGISMap2D" + (Math.random() * 10000).toFixed(0);
    //地图配置
    @Prop({ type: Object }) readonly mapConfig!: any;

    private showWidgets: string[] = [];

    get widgetNames() {
        return this.mapConfig.widgets ? this.mapConfig.widgets.map((widget: any) => widget.name) : [];
    }

    get widgetConfig() {
        const self = this;
        return function (name: string) {
            if (!self.mapConfig.widgets) {
                return {};
            } else {
                const widget = self.mapConfig.widgets.find((widget: any) => widget.name === name);
                return widget ? widget.config : {};
            }
        };
    }

    get view() {
        return this.mapApp.view;
    }

    destroyed() {
        console.log("the arcgis2d destroyed");
        // 清空挂载的vue组件
        const res = this.mapApp?.clearAllComponentOverlay();
        console.log(res);
        // 组件被销毁时，手动清空webgl contexts
        // const div = this.view.container as HTMLDivElement;
        // const canvas = div.querySelector("canvas") as HTMLCanvasElement;
        // const gl = canvas.getContext("webgl") as WebGLRenderingContext;
        // gl.getExtension("WEBGL_lose_context")?.loseContext();
    }

    private showDirection = false;
    @Emit("map-loaded")
    async mounted() {
        this.mapApp = new MapApp();
        await this.mapApp.initialize(this.mapConfig, this.mapId);

        this.mapApp.showGisDeviceInfo = this.showGisDeviceInfo;
        this.mapApp.doubleMarkerClick = this.doubleMarkerClick
        this.mapApp.mouseGisDeviceInfo = this.mouseGisDeviceInfo;
        this.mapApp.mapClick = this.mapClick;
        this.mapApp.selectRouteFinished = this.selectedRouteFinished;
        this.mapApp.intoSignal = this.intoSignal;
        this.mapApp.outofSignal = this.outofSignal;
        this.mapApp.mapInteractive = this.mapInteractive;
        this.mapApp.layerLoaded = this.layerLoaded;
        this.mapApp.mapZoom = this.mapZoom;
        this.mapApp.mapBoundary = this.mapBoundary;

        if (this.mapConfig.widgets) {
            this.mapConfig.widgets.forEach((widget: any) => {
                if (widget.visible !== false) {
                    this.showWidgets.push(widget.name);
                }
            }, this);
        }
    }
    @Emit("map-click")
    public mapClick(point: object) {}
    @Emit("map-zoom")
    private mapZoom(zoom: { new: number; old: number }) {}
    @Emit("map-boundary")
    private mapBoundary(mapB: { topLeft: any; bottomRight: number }) {}
    @Emit("marker-click")
    public showGisDeviceInfo(type: string, id: string, detail: any, label?: string) {}
    @Emit("double-marker-click")
    public doubleMarkerClick(type: string, id: string, detail: any, label?: string) {}

    @Emit("marker-mouse")
    public mouseGisDeviceInfo(event: any, type: string, id: string, detail: any) {}
    @Emit("layer-loaded")
    public layerLoaded() {}
    @Emit("select-route-finished")
    public selectedRouteFinished(routeInfo: object) {}

    @Emit("into-signal")
    public intoSignal(signalId: string) {}

    @Emit("outof-signal")
    public outofSignal(signalId: string) {}

    @Emit("map-interactive")
    private mapInteractive(viewPoint: __esri.Viewpoint) {}

    public async addOverlays(params: IOverlayParameter): Promise<IResult> {
        return await this.mapApp.addOverlays(params);
    }
    public async addOverlaysLine(params: IOverlayParameter): Promise<IResult> {
        return await this.mapApp.addOverlaysLine(params);
    }
    public async addOverlaysZHZX(params: IOverlayParameter): Promise<IResult> {
        return await this.mapApp.addOverlaysZHZX(params);
    }
    // showToolTip
    public async showToolTip(params: IOverlayDelete): Promise<IResult> {
        return await this.mapApp.showToolTip(params);
    }
    // hideToolTip
    public async hideToolTip(params: IOverlayDelete): Promise<IResult> {
        return await this.mapApp.hideToolTip(params);
    }

    public async getOverlays(params: IOverlayDelete): Promise<IResult> {
        return await this.mapApp.getOverlays(params);
    }
    public async addHeatMap(params: IHeatParameter): Promise<IResult> {
        return this.mapApp.addHeatMap(params);
    }
    public async addHeatMapFromServer(params: IHeatMapParams): Promise<IResult> {
        return this.mapApp.addHeatMapFromServer(params);
    }
    public async addOverlaysCluster(params: IOverlayClusterParameter): Promise<IResult> {
        return await this.mapApp.addOverlaysCluster(params);
    }
    public deleteOverlays(params: IOverlayDelete): Promise<IResult> {
        return this.mapApp.deleteOverlays(params);
    }
    //
    public deleteOverlaysLine(params: IOverlayDelete): Promise<IResult> {
        return this.mapApp.deleteOverlaysLine(params);
    }
    public deleteOverlaysCluster(params: IOverlayDelete) {
        this.mapApp.deleteOverlaysCluster(params);
    }
    public deleteAllOverlays() {
        this.mapApp.deleteAllOverlays();
    }
    public deleteAllOverlaysCluster() {
        this.mapApp.deleteAllOverlaysCluster();
    }
    public deleteHeatMap(params: ILayerConfig) {
        this.mapApp.deleteHeatMap(params);
    }
    public showLayer(params: ILayerConfig) {
        this.mapApp.showLayer(params);
    }
    public hideLayer(params: ILayerConfig) {
        this.mapApp.hideLayer(params);
    }
    public setMapCenter(params: IPointGeometry) {
        this.mapApp.setMapCenter(params);
    }
    public setMapViewpoint(viewpoint: __esri.Viewpoint) {
        this.mapApp.setMapViewpoint(viewpoint);
    }
    public setMapCenterAndLevelZHZX(params: ICenterLevel): Promise<void> {
        return this.mapApp.setMapCenterAndLevelZHZX(params);
    }
    public setMapCenterAndLevel(params: ICenterLevel): Promise<void> {
        return this.mapApp.setMapCenterAndLevel(params);
    }
    public setMapLevel(params: IMapLevel): Promise<void> {
        return this.mapApp.setMapLevel(params);
    }
    public getMapLevel(): number {
        return this.mapApp.getMapLevel();
    }

    public async measure_length(): Promise<IResult> {
        return await this.mapApp.measure_length();
    }

    public async measure_area(): Promise<IResult> {
        return await this.mapApp.measure_area();
    }

    public measure_clear() {
        this.mapApp.measure_clear();
    }

    public showJurisdiction() {}
    public hideJurisdiction() {}
    public showDistrictMask(param: IDistrictParameter) {}
    public hideDistrictMask() {}
    public findFeature(params: IFindParameter): Promise<IResult> {
        return this.mapApp.findFeature(params);
    }
    public findFeatureYp(params: IFindParameter): Promise<IResult> {
        return this.mapApp.findFeatureYp(params);
    }
    public stopHighlightFeature() {
        this.mapApp.stopHighlightFeature();
    }

    public showRoad() {}
    public hideRoad() {}
    public showStreet() {}
    public hideStreet() {}
    public locateStreet(param: IStreetParameter) {}
    public setMapStyle(param: string) {}
    public async routeSearch(params: IRouteParameter): Promise<IResult> {
        return { status: 0, message: "" };
    }
    public clearRouteSearch() {}
    public showRoutePoint(params: any) {}
    public clearRoutePoint() {}
    public async searchShortestPath(params: IRouteParameter): Promise<IResult> {
        return this.mapApp.searchShortestPath(params);
    }
    public async clearShortestPath(): Promise<IResult> {
        return this.mapApp.clearShortestPath();
    }
    public async addDrawLayer(params: any): Promise<IResult> {
        return await this.mapApp.addDrawLayer(params);
    }
    public clearDrawLayer(params: any) {
        this.mapApp.clearDrawLayer(params);
    }
    public addHeatImage(params: IHeatImageParameter) {
        this.mapApp.addHeatImage(params);
    }
    public deleteHeatImage() {
        this.mapApp.deleteHeatImage();
    }
    public showMigrateChart(params: any) {
        this.mapApp.showMigrateChart(params);
    }
    public showODData(params: any) {
        this.mapApp.showODData(params);
    }
    public showSubwayMigrateChart(params: any) {
        this.mapApp.showSubwayMigrateChart(params);
    }
    public hideMigrateChart(params?: any) {
        this.mapApp.hideMigrateChart(params);
    }
    public showBarChart(params: any) {
        this.mapApp.showBarChart(params);
    }
    public hideBarChart() {
        this.mapApp.hideBarChart();
    }
    public clearArrowLayer() {
        this.mapApp.clearArrowLayer();
    }
    public async startGeometrySearch(params: IGeometrySearchParameter): Promise<IResult> {
        return this.mapApp.startGeometrySearch(params);
    }
    public clearGeometrySearch() {
        this.mapApp.clearGeometrySearch();
    }
    // public async showDgene(params: any): Promise<IResult> {
    //   return await this.mapApp.showDgene(params);
    // }
    // public hideDgene() {
    //   this.mapApp.hideDgene();
    // }
    // public async addDgeneFusion(params: any): Promise<IResult> {
    //   return await this.mapApp.addDgeneFusion(params);
    // }
    // public async restoreDegeneFsion(): Promise<IResult> {
    //   return await this.mapApp.restoreDegeneFsion();
    // }
    public showCustomTip(params: ICustomTip) {
        this.mapApp.showCustomTip(params);
    }
    // public showDgeneOutPoint(params: any) {
    //   this.mapApp.showDgeneOutPoint(params);
    // }
    // public changeDgeneOut() {
    //   this.mapApp.changeDgeneOut();
    // }

    /**
     * 路段选择
     * 选择起点路段，显示后续路段，最终完成一个完整路段
     */
    /**
     * 初始化路段选择数据，地图上显示路段，进入路段选择状态
     * @param enableXHJ 是否自动选择信号机
     * */
    public async initializeRouteSelect(params: ISelectRouteParam) {
        await this.mapApp.initializeRouteData(params);
    }

    public async showSelectedRoute(params: ISelectRouteResult) {
        await this.mapApp.showSelectedRoute(params);
    }

    public async playSelectedRoute(speed: number) {
        await this.mapApp.playSelectedRoute(speed);
    }

    public stopPlaySelectedRoute() {
        this.mapApp.stopPlaySelectedRoute();
    }

    public async routeHitArea(params: ISelectRouteHitTest): Promise<IResult> {
        return await this.mapApp.routeHitArea(params);
    }

    public async areaHitRoute(params: ISelectRouteHitTest): Promise<IResult> {
        return await this.mapApp.areaHitRoute(params);
    }

    public async startDrawOverlays(params: IDrawOverlays): Promise<void> {
        return await this.mapApp.startDrawOverlays(params);
    }
    public async stopDrawOverlays(): Promise<void> {
        return await this.mapApp.stopDrawOverlays();
    }
    public async deleteDrawOverlays(params: IOverlayDelete): Promise<void> {
        return await this.mapApp.deleteDrawOverlays(params);
    }
    public async getDrawOverlays(): Promise<IResult> {
        return await this.mapApp.getDrawOverlays();
    }
    public async startLayerSearch(params: IGeometrySearchParameter): Promise<IResult> {
        return await this.mapApp.startLayerSearch(params);
    }
    public async startLayerDefinition(params: IDefinitionParameter): Promise<void> {
        return await this.mapApp.startLayerDefinition(params);
    }
    public async startTrackPlay(params: ITrackParameter): Promise<void> {
        this.mapApp.startTrackPlay(params);
    }
    public stopTrackPlay() {
        this.mapApp.stopTrackPlay();
    }
    public async getRegionOverlays(params: IOverlayParameter): Promise<IResult> {
        return await this.mapApp.getRegionOverlays(params);
    }

    public startWatchMapCenter() {
        this.mapApp.startWatchMapCenter();
    }

    public stopWatchMapCenter() {
        this.mapApp.stopWatchMapCenter();
    }

    public async addAnimatePoints(params: IOverlayParameter): Promise<IResult> {
        return { status: -2, message: "no function" };
    }
    public async deleteAnimatePoints(params?: IOverlayDelete): Promise<IResult> {
        return { status: -2, message: "no function" };
    }

    public async addAnimateLines(params: IAnimateLineAddParams): Promise<IResult> {
        return this.mapApp.addAnimateLines(params);
    }

    public async deleteAnimateLines(params: IAnimateLineDelParams): Promise<IResult> {
        return this.mapApp.deleteAnimateLines(params);
    }

    public async startSignalPhase(params: ISignalPhaseInfo): Promise<IResult> {
        return { status: -2, message: "no function" };
    }

    public async connectSumoSimulation(params: ISumoConnectInfo): Promise<IResult> {
        return await this.mapApp.connectSumoSimulation(params);
    }

    public disconnectSumoSimulation() {
        this.mapApp.disconnectSumoSimulation();
    }

    public async connectRealTimeSimulation(params: ISumoConnectInfo): Promise<IResult> {
        return await this.mapApp.connectRealTimeSimulation(params);
    }

    public disconnectRealTimeSimulation() {
        this.mapApp.disconnectRealTimeSimulation();
    }

    public focusOnVehicle(id: string) {
        this.mapApp.focusOnVehicle(id);
    }

    public cancelFocusOnVehicle() {
        this.mapApp.cancelFocusOnVehicle();
    }

    public async showPopup(params: IPopUpTemplate) {
        this.mapApp.showPopup(params);
    }
    public closePopup() {
        this.mapApp.closePopup();
    }
    public toggleWidget(params: string[]) {
        this.mapApp.toggleWidget(params);
    }
    public setWidgetPos(params: Array<IWidget>) {
        if (this.mapApp.setWidgetPos) {
            this.mapApp.setWidgetPos(params);
        }
    }
    public toggleLayerByYear(year: string) {
        this.mapApp.toggleLayerByYear(year);
    }

    public async addQueryIntersect(params: IQueryParameter) {
        this.mapApp.addQueryIntersect(params);
    }
    public async deleteQueryIntersect(params: string | undefined) {
        this.mapApp.deleteQueryIntersect(params);
    }

    public async route_initialize(params?: { cameraUrl: string; token: string; showRoad?: boolean }) {
        return await this.mapApp.route_initialize(params);
    }

    public async route_addStartPoint(): Promise<IResult> {
        return await this.mapApp.route_addStartPoint();
    }

    public async route_addEndPoint(): Promise<IResult> {
        return await this.mapApp.route_addEndPoint();
    }

    public async route_addWayPoint(index: number): Promise<IResult> {
        return await this.mapApp.route_addWayPoint(index);
    }

    public route_deleteWayPoint(index: number): IResult {
        return this.mapApp.route_deleteWayPoint(index);
    }

    public async route_getRoute(): Promise<IResult> {
        return await this.mapApp.route_getRoute();
    }

    public async route_getMultiRoutes(params: IMultiStartRoute): Promise<IResult> {
        return this.mapApp.route_getMultiRoutes(params);
    }

    public async route_showRoute(params: { strategy?: string; coordinates?: string; signalIds?: string[] }): Promise<IResult> {
        return await this.mapApp.route_showRoute(params);
    }

    public async route_clearRoutes() {
        return await this.mapApp.route_clearRoutes();
    }

    public async route_focusCross(crossId: string): Promise<IResult> {
        return this.mapApp.route_focusCross(crossId);
    }

    public route_play(speed: number) {
        return this.mapApp.route_play(speed);
    }

    public route_stop() {
        return this.mapApp.route_stop();
    }

    public route_pause() {
        return this.mapApp.route_pause();
    }

    public route_resume() {
        return this.mapApp.route_resume();
    }

    public async route_routeHitArea(params: IRouteHitTestParam): Promise<IResult> {
        return await this.mapApp.route_routeHitArea(params);
    }

    public async route_areaHitRoute(params: IRouteHitTestParam): Promise<IResult> {
        return await this.mapApp.route_areaHitRoute(params);
    }

    public route_showHitResult(params: IRouteHitTestResultParam) {
        this.mapApp.route_showHitResult(params);
    }

    public initializeLaneSignalPhase(crossId: string) {
        return this.mapApp.initializeLaneSignalPhase(crossId);
    }

    public startLaneSignalPhase(laneSignalPhaseInfos: ILaneSignalPhaseInfo[]) {
        return this.mapApp.startLaneSignalPhase(laneSignalPhaseInfos);
    }

    public test() {
        this.mapApp.test();
    }

    public async startTrackLine(params: ITrackLineParameter): Promise<IResult> {
        return await this.mapApp.startTrackLine(params);
    }
    public stopTrackLine() {
        this.mapApp.stopTrackLine();
    }

    public async getMapOption(): Promise<IResult> {
        return await this.mapApp.getMapOption();
    }

    public showCrossTrack(crosses: Array<ITrackCross>) {
        return this.mapApp.showCrossTrack(crosses);
    }

    public hideCrossTrack() {
        this.mapApp.hideCrossTrack();
    }

    public showCrossTrackHighlight(crossId: string) {
        this.mapApp.showCrossTrackHighlight(crossId);
    }

    public queryCrossInView(params: ICrossInView): IResult {
        return this.mapApp.queryCrossInView(params);
    }

    public async dynamicLayer_initialize(configFile: string) {
        await this.mapApp.dynamicLayer_initialize(configFile);
    }

    public async dynamicLayer_show(params: IDynamicLayerDataParams) {
        await this.mapApp.dynamicLayer_show(params);
    }

    public dynamicLayer_hide(params: IDynamicLayerDataParams) {
        this.mapApp.dynamicLayer_hide(params);
    }

    public async jsonLayer_add(params: ILayerConfig): Promise<void> {
        await this.mapApp.jsonLayer_add(params);
    }

    public toScreen(params: { x: number; y: number }): IResult {
        return this.mapApp.toScreen(params);
    }

    public toMap(params: { x: number; y: number }): IResult {
        return this.mapApp.toMap(params);
    }

    public showImage() {
        this.mapApp.showImage();
    }

    public async addComponentOverlay(params: IComponentOverlayParam): Promise<IResult> {
        return await this.mapApp.addComponentOverlay(params);
    }

    public deleteComponentOverlay(params?: IOverlayDelete) {
        return this.mapApp.deleteComponentOverlay(params);
    }

    public async addCustomComponentOverlay(params: IComponentOverlayParam): Promise<IResult> {
        return await this.mapApp.addCustomComponentOverlay(params);
    }

    public async setMapControl(params: IMapControlParam) {
        return await this.mapApp.setMapControl(params);
    }

    public moveLayerToTop(params: any): IResult {
        return this.mapApp.moveLayerToTop(params);
    }

    public reorderLayer(params: any): IResult {
        return this.mapApp.reorderLayer(params);
    }
}
